import { Action } from '@ngrx/store';
import { createActionType } from '@app/store/store.utils';

export const LOGIN = createActionType('LOGIN');
export const ASSISTED_MODE_LOGIN = createActionType('ASSISTED_MODE_LOGIN');
export const ASSISTED_MODE_CLIENT_LOGIN = createActionType('ASSISTED_MODE_CLIENT_LOGIN');
export const LOGOUT = createActionType('LOGOUT');
export const FIRST_ACCESS_LOGIN = createActionType('FIRST_ACCESS_LOGIN');
export const LOGIN_SUCCESS = createActionType('LOGIN_SUCCESS');
export const LOGIN_FAILURE = createActionType('LOGIN_FAILURE');
export const LOGIN_REDIRECT = createActionType('LOGIN_REDIRECT');

export class LogIn implements Action {
  readonly type = LOGIN;
  constructor(public payload: any) {}
}

export class AssistedModeLogin implements Action {
  readonly type = ASSISTED_MODE_LOGIN;
  constructor(public payload: any) {}
}

export class AssistedModeCpfClientLogIn implements Action {
  readonly type = ASSISTED_MODE_CLIENT_LOGIN;
  constructor(public payload: any) {}
}

export class LogOut implements Action {
  readonly type = LOGOUT;
}

export class FirstAccessLogIn implements Action {
  readonly type = FIRST_ACCESS_LOGIN;
  constructor(public payload: any) {}
}

export class LogInSuccess implements Action {
  readonly type = LOGIN_SUCCESS;
  constructor(public payload: any) {}
}

export class LogInFailure implements Action {
  readonly type = LOGIN_FAILURE;
  constructor(public payload: any) {}
}

export class LogInRedirect implements Action {
  readonly type = LOGIN_REDIRECT;
}

export type AuthAction =
  | LogIn
  | AssistedModeLogin
  | AssistedModeCpfClientLogIn
  | LogInSuccess
  | LogInFailure
  | LogInRedirect
  | FirstAccessLogIn
  | LogOut;
